<template>
  <div class="page2 page">
    <div class="border">
      <div class="page-center">
        <div class="page1_box">
          
          <img src="../assets/img/jg0/tapcy.png" alt="" class="shous">

          <img src="" alt="" class="saveImage">


          <!--对应6个题序号--->

          <div class="jgwu bian t0">
            <span></span><span></span><span></span>
          </div>

          <div class="jgwu bian t1">
            <span></span><span></span><span></span>
            <img src="../assets/img/jtw1.png" alt="">
          </div>
          <!--达尔文--->
          <!-- <div class="jgwu bian t2">
            <span></span><span></span><span></span>
          </div> -->
          <!--华罗庚--->
          <div class="jgwu bian t2">
            <span></span><span></span><span></span>
            <img src="../assets/img/jtw1.png" alt="">
          </div>
          <!--拉瓦锡--->
          <div class="jgwu bian t3">
            <span></span><span></span><span></span>
            <img src="../assets/img/jtw1.png" alt="">
          </div>
          <!--张衡--->
          <div class="jgwu bian t4">
            <span></span><span></span><span></span>
            <img src="../assets/img/jtw1.png" alt="">
          </div>
          <!--莱特兄弟--->
          <div class="jgwu bian t5">
            <span></span><span></span><span></span>
            <img src="../assets/img/jtw1.png" alt="">
          </div>
          <!--徐霞客--->
         
         <div class="page2_boa">
            <img
            src=""
            class="w100 xuhao"
            /><!--对应6个题序号，前面有一层目录对应答对几个--->
         </div>

          <p class="p-xta">你家小宝贝 <span></span> 的大师DNA里</p>
          <!-- <img src="../assets/img/page_jg_2.png" alt="" class="backhome" @click="backhome" />
          <img src="../assets/img/page_jg_3.png" alt="" class="wail" @click="tiaozhjuan"/> -->

          <div class="tiaozhuans" @click="tiaozhjuan">
            <img src="../assets/img/zdpy.png" alt=""    class="img">
            <img src="../assets/img/jtw1.png" alt="" class="jaintounn">
          </div>

        </div>
      </div>
          <img src="../assets/img/zcyc.png" alt="" class="backhome"  @click="backhome">

    <!-- <img src="../assets/img/savetips.png" alt="" class="l-t-tips" /> -->
    </div>
      <div class="border-center-r"></div>

    <!-- <img src="../assets/img/savetip.png" alt="" class="l-t-tips"> -->

  </div>
</template>
<script>

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg);  //匹配目标参数
  if (r != null) return unescape(r[2]); return null; //返回参数值
}

export default {
  components: {},
  data() {
    return {};
  },

  mounted: function () {},
  methods: {
    backhome(){
        let ADTAG = getUrlParam("ADTAG");
      if(ADTAG){
        location.replace('https://helloyoung.qq.com/young2022/?ADTAG='+ADTAG);
      }else{
        location.replace('https://helloyoung.qq.com/young2022/');
      }
    },
    tiaozhjuan(){
      this.report("click_activity", {path:'young2022'});   
      setTimeout(()=>{
        this.$parent.tiaozhjuan();
      },100); 
    }
  },
};
</script>

<style lang="less">
@vw: 7.5vw;
@vh: 13.33vh;
@import url("../assets/css/share.less");
</style>
